import React from 'react';
import { AccessContext, IAccessContext } from './AccessContext';

export default <Props extends object>(ComponentToWrap: React.ComponentType<Props>) => (
  class WithAccess extends React.Component<Props> {
    static contextType = AccessContext;

    render() {
      const { accessManager } = this.context as IAccessContext;

      return (
        <ComponentToWrap
          {...this.props}
          accessManager={accessManager}
        />
      );
    }
  }
);
